import React from 'react';

import tumLogoPic from '../../assets/images/tum_logo.png';
import tehranLogoPic from '../../assets/images/tehran_logo.png';

import './educationSection.css';

const EducationSection = () => {
  return (
    <section className="educationSection" id="educationSection">
      <div className="titleEducation">
        <h2>My Education</h2>
      </div>

      <div className="containerEducation">
        {/* LEFT: TUM */}
        <div className="containerEducationLeft">
          <div className="educationItem">
            <div className="educationText">
              <h2 className="eduSchool">Technical University of Munich (TUM)</h2>
              <h3 className="eduDegree">Computational Mechanics MSc</h3>
              <p className="eduBody">
                Focus on <span className="aBoldText">finite element methods</span>,{' '}
                <span className="aBoldText">computational fluid dynamics</span>, and{' '}
                <span className="aBoldText">data-driven modeling</span>. Strong emphasis on numerical
                simulation, machine learning integration, and industry-oriented research.
              </p>
            </div>

            <a
              className="eduLogoWrap"
              href="https://www.tum.de/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit TUM website"
            >
              <img className="institutionLogo" src={tumLogoPic} alt="TUM Logo" />
            </a>
          </div>
        </div>

        {/* RIGHT: Tehran */}
        <div className="containerEducationRight">
          <div className="educationItem">
            <div className="educationText">
              <h2 className="eduSchool">University of Tehran</h2>
              <h3 className="eduDegree">Mechanical Engineering BSc </h3>
              <p className="eduBody">
                Solid foundation in <span className="aBoldText">thermodynamics</span>,{' '}
                <span className="aBoldText">fluid mechanics</span>, and{' '}
                <span className="aBoldText">machine design</span>. Project-based coursework motivated
                my later specialization in computational and data-driven approaches.
              </p>
            </div>

            <a
              className="eduLogoWrap"
              href="https://ut.ac.ir/en"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit University of Tehran website"
            >
              <img className="institutionLogo" src={tehranLogoPic} alt="University of Tehran Logo" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
